import { Controller } from "@hotwired/stimulus";
import Tooltip from "bootstrap-latest/js/dist/tooltip.js";

/**
 * Bootstrap tooltip widget
 * @see {@link https://getbootstrap.com/docs/5.3/components/tooltips/|Bootstrap Docs}
 *
 * @example Basic tooltip with text from the `title` attribute
 *   <button data-controller='tooltip' title='Button to do magic'>
 *     Do Magic
 *   </button>
 *
 * @example Tooltip positioned on the bottom
 *   <button data-controller='tooltip'
 *           title='Button to do magic'
 *           bs-placement='bottom'>
 *     Do Magic
 *   </button>
 *
 * @example Tooltip with left aligned text
 *   <button data-controller='tooltip'
 *           title='Button to do magic'
 *           data-tooltip-body-class='text-start'>
 *     Do Magic
 *   </button>
 */
export default class extends Controller {
  static targets = ["manualTrigger"];
  static values = {
    // How tooltip is triggered - click | hover | focus | manual.
    // You may pass multiple triggers; separate them with a space.
    // It's best to have focus along with hover for accessibility.
    trigger: { type: String, default: "hover focus" }
  };
  static classes = ["outer", "body"];

  initialize() {
    if (this.hasManualTriggerTarget) this.triggerValue = "manual";
    this.tooltip = new Tooltip(this.element, {
      trigger: this.triggerValue,
      template: `<div class="tooltip ${this.outerClasses.join(
        " "
      )}" role="tooltip">
        <div class="tooltip-arrow"></div>
        <div class="tooltip-inner ${this.bodyClasses.join(" ")}"></div>
      </div>`
    });
  }

  toggleEnabled() {
    this.tooltip.toggleEnabled();
  }

  enable() {
    this.tooltip.enable();
  }

  disable() {
    this.tooltip.disable();
  }

  toggle(disable) {
    if (disable) {
      this.disable();
    } else {
      this.enable();
    }
  }

  show() {
    this.tooltip.show();
    this.hide();
  }

  hide() {
    setTimeout(() => {
      this.tooltip.hide();
    }, 2000);
  }

  force_hide() {
    this.hide();
  }

  // Private

  /**
   * Handle when controller disconnects.
   */
  disconnect() {
    // If we don't force hide on disconnect, a tooltip can be left orphaned on
    // when the element the controller is attached to is removed from the page.
    this.force_hide();
    this.tooltip.dispose();
  }
}
